export default "__VITE_ASSET__DeMUdCTt__"